import axios from "@/plugins/Axios";

const model = "autoridad";

function all() {
  return axios.get(`${process.env.VUE_APP_API_URL}/${model}`);
}

function find(id) {
  return axios.get(`${process.env.VUE_APP_API_URL}/${model}/${id}`);
}

function create(autoridad) {
  return axios.post(`${process.env.VUE_APP_API_URL}/${model}`, autoridad);
}

function update(id, autoridad) {
  return axios.put(`${process.env.VUE_APP_API_URL}/${model}/${id}`, autoridad);
}

function remove(id) {
  return axios.delete(`${process.env.VUE_APP_API_URL}/${model}/${id}`);
}

export { all, find, create, update, remove };
